import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getKotelezoSzakmaiGyakorlat, createKotelezoSzakmaiGyakorlat, updateKotelezoSzakmaiGyakorlat, getSzak } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import "./RadioButton.css";
import "./SzakjelentesCreate.css";
import SideTile from "../SideTile";
import { useDropzone } from "react-dropzone";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import TopAlert from '../../components/TopAlert'; 
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { KOTELEZOSZAKMAIGYAKORLAT_TRANSLATIONS } from './KotelezoSzakmaiGyakorlatTranslations';
import { GYAKORLAT_INFORMACIOK_OPTIONS, PARTNEREK_SZAMA_OPTIONS, PARTNEREK_TIPUSA_OPTIONS, ALUMNI_KAPCSOLAT_OPTIONS, VALLALATI_KAPCSOLAT_OPTIONS, SZAKMAI_SZERVEZET_OPTIONS } from './KotelezoSzakmaiGyakorlatOptions.js';


const KotelezoSzakmaiGyakorlatContent = ({ szakKod }) => {
    const { language, loading } = useLanguage();
    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const [kotelezoGyakorlat, setKotelezoGyakorlat] = useState({
        filling_status: 1,
    });

    const [images, setImages] = useState({
        szakmai_gyakorlat_partnerek_image: []
    });
    const [isNew, setIsNew] = useState(true);
    const [finalized, setFinalized] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null); // Kép kiválasztása nagyításhoz
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés
    
    // State for radio button selections
    const [gyakorlatInformaciok, setGyakorlatInformaciok] = useState("");
    const [partnerekSzama, setPartnerekSzama] = useState("");
    const [partnerekTipusa, setPartnerekTipusa] = useState([]); // Changed to array for checkboxes
    const [partnerekTipusaEgyeb, setPartnerekTipusaEgyeb] = useState("");
    const [alumniKapcsolat, setAlumniKapcsolat] = useState("");
    const [vallalatiKapcsolat, setVallalatiKapcsolat] = useState("");
    const [szakmaiSzervezet, setSzakmaiSzervezet] = useState("");

    // Translations and options setup
    const t = loading ? {} : (KOTELEZOSZAKMAIGYAKORLAT_TRANSLATIONS[language] || KOTELEZOSZAKMAIGYAKORLAT_TRANSLATIONS.hu);
    const gyakorlatInformaciokOptions = loading ? [] : (GYAKORLAT_INFORMACIOK_OPTIONS[language] || GYAKORLAT_INFORMACIOK_OPTIONS.hu);
    const partnerekSzamaOptions = loading ? [] : (PARTNEREK_SZAMA_OPTIONS[language] || PARTNEREK_SZAMA_OPTIONS.hu);
    const partnerekTipusaOptions = loading ? [] : (PARTNEREK_TIPUSA_OPTIONS[language] || PARTNEREK_TIPUSA_OPTIONS.hu);
    const alumniKapcsolatOptions = loading ? [] : (ALUMNI_KAPCSOLAT_OPTIONS[language] || ALUMNI_KAPCSOLAT_OPTIONS.hu);
    const vallalatiKapcsolatOptions = loading ? [] : (VALLALATI_KAPCSOLAT_OPTIONS[language] || VALLALATI_KAPCSOLAT_OPTIONS.hu);
    const szakmaiSzervezetOptions = loading ? [] : (SZAKMAI_SZERVEZET_OPTIONS[language] || SZAKMAI_SZERVEZET_OPTIONS.hu);

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build JSONB structure for multi-select checkboxes
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!szakId) {
                return;
            }
            try {
                // Szakadatok bekérése a státusz ellenőrzéséhez
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const kotelezoSzakmaiGyakorlatResponse = await getKotelezoSzakmaiGyakorlat(szakId);
                if (kotelezoSzakmaiGyakorlatResponse.data && kotelezoSzakmaiGyakorlatResponse.data.data && kotelezoSzakmaiGyakorlatResponse.data.data.szakKotelezSzakmaiGyakorlat?.[0]) {
                    const data = kotelezoSzakmaiGyakorlatResponse.data.data.szakKotelezSzakmaiGyakorlat[0];
                    setKotelezoGyakorlat(data);
                    setFinalized(data.filling_status === 3);
                    await fetchImages();
                    if (data.gyakorlat_informaciok) setGyakorlatInformaciok(data.gyakorlat_informaciok.selected || "");
                    if (data.partnerek_szama) setPartnerekSzama(data.partnerek_szama.selected || "");
                    if (data.partnerek_tipusa) setPartnerekTipusa(data.partnerek_tipusa.selected || []);
                    if (data.partnerek_tipusa_egyeb) setPartnerekTipusaEgyeb(data.partnerek_tipusa_egyeb);
                    if (data.alumni_kapcsolat) setAlumniKapcsolat(data.alumni_kapcsolat.selected || "");
                    if (data.vallalati_kapcsolat) setVallalatiKapcsolat(data.vallalati_kapcsolat.selected || "");
                    if (data.szakmai_szervezet) setSzakmaiSzervezet(data.szakmai_szervezet.selected || "");
                    setIsNew(false);
                } else {
                    // Return empty data when no record exists
                    setKotelezoGyakorlat({
                        szak_id: szakId,
                        gyakorlat_informaciok: null,
                        partnerek_szama: null,
                        partnerek_tipusa: null,
                        partnerek_tipusa_egyeb: null,
                        alumni_kapcsolat: null,
                        vallalati_kapcsolat: null,
                        szakmai_szervezet: null,
                        szakmai_gyakorlat_info: null,
                        szakmai_gyakorlat_partnerek: null,
                        filling_status: 0
                    });
                    setFinalized(false);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                // Handle error by setting empty data
                setKotelezoGyakorlat({
                    szak_id: szakId,
                    gyakorlat_informaciok: null,
                    partnerek_szama: null,
                    partnerek_tipusa: null,
                    partnerek_tipusa_egyeb: null,
                    alumni_kapcsolat: null,
                    vallalati_kapcsolat: null,
                    szakmai_szervezet: null,
                    szakmai_gyakorlat_info: null,
                    szakmai_gyakorlat_partnerek: null,
                    filling_status: 0
                });
            }
        };
        fetchData();
    }, [szakId]);

    // Auto-save empty record with filling_status=1 when page first loads
    useEffect(() => {
        const initializeRecord = async () => {
            if (isNew && kotelezoGyakorlat.filling_status === 0) {
                try {
                    const initialData = {
                        ...kotelezoGyakorlat,
                        filling_status: 1,
                        gyakorlat_informaciok: null,
                        partnerek_szama: null,
                        partnerek_tipusa: null,
                        partnerek_tipusa_egyeb: null,
                        alumni_kapcsolat: null,
                        vallalati_kapcsolat: null,
                        szakmai_szervezet: null
                    };
                    await createKotelezoSzakmaiGyakorlat(szakId, initialData);
                    setIsNew(false);
                    // SideTile status is fetched on mount; reload once so the new status (1) is reflected.
                    window.location.reload();
                } catch (error) {
                    console.error("Error initializing record:", error);
                }
            }
        };
        initializeRecord();
    }, [isNew, szakId, kotelezoGyakorlat.filling_status]);

    const fetchImages = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakok/${szakId}/images/szakmai_gyakorlat_partnerek_image`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
    
            if (!response.ok) {
                throw new Error('Failed to fetch images');
            }
    
            const data = await response.json();
            setImages({
                szakmai_gyakorlat_partnerek_image: data.data || []
            });
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };
    
    const handleDrop = async (acceptedFiles) => {
        if (finalized) return;
    
        const formData = new FormData();
        formData.append('image', acceptedFiles[0]);
        formData.append('section', 'szakmai_gyakorlat_partnerek_image');
    
        try {
            const baseUrl = process.env.REACT_APP_API_BASE_URL; // Környezeti változó használata
            // Token nélküli feltöltési kérés
            const response = await fetch(`${baseUrl}/upload/${szakId}`, {
                method: 'POST',
                body: formData,
            });
    
            if (!response.ok) {
                throw new Error('Failed to upload image');
            }
    
            const uploadResponse = await response.json();
    
            if (uploadResponse && uploadResponse.image_path) {
                const imagePath = uploadResponse.image_path.replace('uploads/', '');
                setImages((prevImages) => ({
                    ...prevImages,
                    szakmai_gyakorlat_partnerek_image: [
                        ...prevImages.szakmai_gyakorlat_partnerek_image,
                        { id: uploadResponse.id, image_path: imagePath }
                    ]
                }));
            } else {
                console.error('Unexpected response format:', uploadResponse);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };
    
    
    const handleDeleteImage = async (imageId) => {
        if (finalized) return;
    
        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakjelentes_letrehozas/${szakId}/images/${imageId}`, {
                method: 'DELETE',
            });
    
            setImages((prevImages) => ({
                ...prevImages,
                szakmai_gyakorlat_partnerek_image: prevImages.szakmai_gyakorlat_partnerek_image.filter(img => img.id !== imageId)
            }));
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };
    

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: handleDrop,
        accept: 'image/*',
        disabled: finalized
    });

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { 
                ...kotelezoGyakorlat, 
                filling_status: 2,
                gyakorlat_informaciok: buildRadioData(gyakorlatInformaciok, GYAKORLAT_INFORMACIOK_OPTIONS),
                partnerek_szama: buildRadioData(partnerekSzama, PARTNEREK_SZAMA_OPTIONS),
                partnerek_tipusa: buildMultiSelectData(partnerekTipusa, PARTNEREK_TIPUSA_OPTIONS),
                partnerek_tipusa_egyeb: partnerekTipusaEgyeb,
                alumni_kapcsolat: buildRadioData(alumniKapcsolat, ALUMNI_KAPCSOLAT_OPTIONS),
                vallalati_kapcsolat: buildRadioData(vallalatiKapcsolat, VALLALATI_KAPCSOLAT_OPTIONS),
                szakmai_szervezet: buildRadioData(szakmaiSzervezet, SZAKMAI_SZERVEZET_OPTIONS),
            };
            try {
                if (isNew) {
                    await createKotelezoSzakmaiGyakorlat(szakId, updatedData);
                } else {
                    await updateKotelezoSzakmaiGyakorlat(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [kotelezoGyakorlat, isNew, szakId, registerSaveHandler, unregisterSaveHandler, gyakorlatInformaciok, partnerekSzama, partnerekTipusa, partnerekTipusaEgyeb, alumniKapcsolat, vallalatiKapcsolat, szakmaiSzervezet]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        const updatedData = { 
            ...kotelezoGyakorlat, 
            filling_status: status, 
            gyakorlat_informaciok: buildRadioData(gyakorlatInformaciok, gyakorlatInformaciokOptions),
            partnerek_szama: buildRadioData(partnerekSzama, partnerekSzamaOptions),
            partnerek_tipusa: buildMultiSelectData(partnerekTipusa, partnerekTipusaOptions),
            partnerek_tipusa_egyeb: partnerekTipusaEgyeb,
            alumni_kapcsolat: buildRadioData(alumniKapcsolat, alumniKapcsolatOptions),
            vallalati_kapcsolat: buildRadioData(vallalatiKapcsolat, vallalatiKapcsolatOptions),
            szakmai_szervezet: buildRadioData(szakmaiSzervezet, szakmaiSzervezetOptions),
        };

        try {
            if (isNew) {
                await createKotelezoSzakmaiGyakorlat(szakId, updatedData);
                setIsNew(false);
            } else {
                await updateKotelezoSzakmaiGyakorlat(szakId, updatedData);
            }
            setKotelezoGyakorlat(updatedData);
            setFinalized(status === 3);
            window.location.reload();
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error submitting data.");
        }
    };

    const isFormValid = () => {
        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        const hasAllRadioSelections = gyakorlatInformaciok && partnerekSzama && partnerekTipusa && alumniKapcsolat && vallalatiKapcsolat && szakmaiSzervezet;

        // Check "egyéb" text fields only if "egyéb" is selected
        const egyebFieldsValid = 
            (!partnerekTipusa.includes('egyeb') || hasContent(partnerekTipusaEgyeb));

        return (
            hasAllRadioSelections && egyebFieldsValid
        );
    };

    const handleFinalize = (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3);
        } else {
            setAlertMessage(t.alerts.requiredFields);
            setShowAlert(true);
        }
    };

    const handleRevertFinalize = (e) => {
        handleSubmit(e, 2);
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/mintatanterv-fejlesztesek`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/idegen-nyelvi-korulmenyek`);
    };
    
    const handleChange = (field, value) => {
        setKotelezoGyakorlat(prevState => ({
          ...prevState,
          [field]: value, // Save the updated HTML content
        }));
      };

    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1>{t.pageTitle}</h1>
                <p>{t.source} <a href="https://seafile.sze.hu/f/b3fa6d4432df4efbaba4/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/b3fa6d4432df4efbaba4/</a> </p>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <div className="card">
                        <h4>{t.section1.subtitle1}</h4>
                        <div className="form-group">
                        {gyakorlatInformaciokOptions.map((option) => (
                            <div className="radio-group" key={option.value}>
                                <input
                                    type="radio"
                                    id={`gyakorlat_informaciok_${option.value}`}
                                    name="gyakorlat_informaciok"
                                    value={option.value}
                                    checked={gyakorlatInformaciok === option.value}
                                    onChange={(e) => setGyakorlatInformaciok(e.target.value)}
                                    disabled={finalized}
                                />
                            <label htmlFor={`gyakorlat_informaciok_${option.value}`}>{option.label}</label>
                            </div>
                        ))}
                        </div>

                        <h4>{t.section1.subtitle2}</h4>
                        <div className="form-group">
                        {partnerekSzamaOptions.map((option) => (
                            <div className="radio-group" key={option.value}>
                                <input
                                    type="radio"
                                    id={`partnerek_szama_${option.value}`}
                                    name="partnerek_szama"
                                    value={option.value}
                                    checked={partnerekSzama === option.value}
                                    onChange={(e) => setPartnerekSzama(e.target.value)}
                                    disabled={finalized}
                                />
                            <label htmlFor={`partnerek_szama_${option.value}`}>{option.label}</label>
                            </div>
                        ))}
                        </div>
                        
                        <h4>{t.section1.subtitle3}</h4>
                        <div className="form-group">
                        {partnerekTipusaOptions.map((option) => (
                            <div className="checkbox-group" key={option.value}>
                                <input
                                    type="checkbox"
                                    id={`partnerek_tipusa_${option.value}`}
                                    name="partnerek_tipusa"
                                    value={option.value}
                                    checked={partnerekTipusa.includes(option.value)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setPartnerekTipusa([
                                                ...partnerekTipusa,
                                                option.value
                                            ]);
                                        } else {
                                            setPartnerekTipusa(
                                                partnerekTipusa.filter(val => val !== option.value)
                                            );
                                        }
                                    }}
                                    disabled={finalized}
                                />
                            <label htmlFor={`partnerek_tipusa_${option.value}`}>{option.label}</label>
                            </div>
                        ))}
                        {partnerekTipusa.includes('egyeb') && (
                            <div className="egyeb-editor-container">
                                <RichTextEditor
                                    name="partnerek_tipusa_egyeb"
                                    value={partnerekTipusaEgyeb}
                                    onChange={setPartnerekTipusaEgyeb}
                                    disabled={finalized}
                                />
                            </div>
                        )}
                        </div>
                        </div>
                        <div className="card">
                        <h3>{t.section2.title}</h3>   
                        <h4>{t.section2.subtitle1}</h4>
                        <div className="form-group">
                        {alumniKapcsolatOptions.map((option) => (
                            <div className="radio-group" key={option.value}>
                                <input
                                    type="radio"
                                    id={`alumni_kapcsolat_${option.value}`}
                                    name="alumni_kapcsolat"
                                    value={option.value}
                                    checked={alumniKapcsolat === option.value}
                                    onChange={(e) => setAlumniKapcsolat(e.target.value)}
                                    disabled={finalized}
                                />
                            <label htmlFor={`alumni_kapcsolat_${option.value}`}>{option.label}</label>
                            </div>
                        ))}
                        </div>

                        <h4>{t.section2.subtitle2}</h4>
                        <div className="form-group">
                        {vallalatiKapcsolatOptions.map((option) => (
                            <div className="radio-group" key={option.value}>
                                <input
                                    type="radio"
                                    id={`vallalati_kapcsolat_${option.value}`}
                                    name="vallalati_kapcsolat"
                                    value={option.value}
                                    checked={vallalatiKapcsolat === option.value}
                                    onChange={(e) => setVallalatiKapcsolat(e.target.value)}
                                    disabled={finalized}
                                />
                            <label htmlFor={`vallalati_kapcsolat_${option.value}`}>{option.label}</label>
                            </div>
                        ))}
                        </div>

                        <h4>{t.section2.subtitle3}</h4>
                        <div className="form-group">
                        {szakmaiSzervezetOptions.map((option) => (
                            <div className="radio-group" key={option.value}>
                                <input
                                    type="radio"
                                    id={`szakmai_szervezet_${option.value}`}
                                    name="szakmai_szervezet"
                                    value={option.value}
                                    checked={szakmaiSzervezet === option.value}
                                    onChange={(e) => setSzakmaiSzervezet(e.target.value)}
                                    disabled={finalized}
                                />
                            <label htmlFor={`szakmai_szervezet_${option.value}`}>{option.label}</label>
                            </div>
                        ))}
                        </div>
                    

                    </div>

                    <div className="button-container-left">
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        {finalized ? (
                            <button className="szak-button finalize-button" type="button" onClick={handleRevertFinalize} disabled={szakStatus >= 2}>{t.buttons.unfinalize}</button>
                        ) : (
                            <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>{t.buttons.finalize}</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const KotelezoSzakmaiGyakorlat = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <KotelezoSzakmaiGyakorlatContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default KotelezoSzakmaiGyakorlat;
